import { Component } from '@angular/core';

@Component({
  selector: 'app-transform-customer-service',
  standalone: true,
  imports: [],
  templateUrl: './transform-customer-service.component.html',
  styleUrl: './transform-customer-service.component.scss',
})
export class TransformCustomerServiceComponent {}
